if (!customElements.get('melokea-f078-gallery')) {
  customElements.define('melokea-f078-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const hero = this.querySelector('.mk-f078-hero');
      const image = hero && hero.querySelector('img');
      if (!image) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-f078-image]');
        if (!button || !this.contains(button)) return;
        const original = button.dataset.f078Image;
        if (!original) return;
        const thumbnail = button.querySelector('img');
        let source = original;
        let srcset = '';
        const sizes = '(min-width: 1440px) 720px, (min-width: 768px) 50vw, calc(100vw - 32px)';
        try {
          const url = new URL(original, window.location.href);
          const hosted = url.hostname === 'cdn.shopify.com' ||
            (url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/files/'));
          if (url.protocol === 'https:' && hosted && /\.(?:jpe?g|png|webp|avif)$/i.test(url.pathname)) {
            const sized = (width) => {
              const candidate = new URL(url.href);
              candidate.hash = '';
              candidate.searchParams.set('width', String(width));
              return candidate.href;
            };
            srcset = [360, 480, 720, 960, 1280, 1600].map(width => `${sized(width)} ${width}w`).join(', ');
            source = sized(960);
          }
        } catch {}
        image.setAttribute('decoding', 'async');
        if (srcset) {
          image.setAttribute('sizes', sizes);
          image.setAttribute('srcset', srcset);
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
        image.setAttribute('src', source);
        image.setAttribute('data-mk-original', original);
        if (thumbnail) image.alt = thumbnail.alt;
        hero.href = original;
        this.querySelectorAll('button[data-f078-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}
